/**
 * Helper which keeps keys type instead of using string[]
 * from <https://stackoverflow.com/questions/52856496/typescript-object-keys-return-string>
 */
const getKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>;

export default getKeys;
